import { ClientTPRMApi } from 'Api/TPRM/TPRMApi';
import { ConfirmationModal, ConfirmationModalOperationType } from 'Components/Modal/ConfirmationModal/ConfirmationModal';
import { Text } from 'Components/Text/Text';
import { ServiceForNonTprmUser, ThirdPartyService } from 'Models/TPRM';

import styles from './DeleteThirdPartyServiceModal.module.css';

export interface DeleteThirdPartyServiceModalProps {
    hideModal: () => void;
    onSuccess: () => Promise<void>;
    service: ThirdPartyService | ServiceForNonTprmUser;
    tprmApi: ClientTPRMApi;
    userHasFullTprmAccess: boolean;
}

export const DeleteThirdPartyServiceModal = (props: DeleteThirdPartyServiceModalProps) => {
    return (
        <ConfirmationModal
            operationType={ConfirmationModalOperationType.DELETE_AFTER_TYPING_TO_CONFIRM}
            headerText="Delete Third-Party Service"
            areYouSureText={`Are you sure you want to delete "${props.service.name}"?`}
            performOperation={async () => {
                await props.tprmApi.deleteService(props.service.vendor_id, props.service.id);
                await props.onSuccess();
                return 'Third-party service deleted.';
            }}
            hideModal={props.hideModal}
        >
            <ul className={styles.deleteConfirmationList}>
                {/* TODO: Consider changing the wording here if the service is a draft. It may confuse the user to be told things will be deleted that can't have ever been populated for the service. */}
                <li>
                    <Text>The in-progress due diligence workflow (inherent risk questionnaire, due diligence questionnaires, due diligence assessments, and final review) for the third-party service will be deleted.</Text>
                </li>
                <li>
                    <Text>All historical due diligence workflows for the third-party service will be deleted.</Text>
                </li>
                {props.userHasFullTprmAccess && (props.service as ThirdPartyService).assessment_workflow_setup.common_assessment_children.length > 0 && (
                    <>
                        <li>
                            <Text>
                                <b>This third-party service is sharing its due diligence assessments with other services.</b> If you delete it, the following third-party services will not have any due diligence assessments until their inherent risk questionnaires are submitted again:
                            </Text>
                        </li>
                        <ul>
                            <Text>
                                {(props.service as ThirdPartyService).assessment_workflow_setup.common_assessment_children.map((child) => {
                                    return <li key={child.id}>{child.name}</li>;
                                })}
                            </Text>
                        </ul>
                    </>
                )}
            </ul>
        </ConfirmationModal>
    );
};
